export enum AnalyticsInterval {
    FifteenMinutes = "FifteenMinutes",
    Hour = "Hour",
    Day = "Day"
}

export const AnalyticsIntervalUtil = {
    getStringValue: (interval: AnalyticsInterval | null | undefined): string => {
        switch (interval) {
            case AnalyticsInterval.FifteenMinutes:
                return "15 минут";
            case AnalyticsInterval.Hour:
                return "Час";
            case AnalyticsInterval.Day:
                return "День";
            default:
                return "";
        }
    }
};

